import { render, staticRenderFns } from "./updataXls.vue?vue&type=template&id=00cfb974&scoped=true"
import script from "./updataXls.vue?vue&type=script&lang=js"
export * from "./updataXls.vue?vue&type=script&lang=js"
import style0 from "./updataXls.vue?vue&type=style&index=0&id=00cfb974&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cfb974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00cfb974')) {
      api.createRecord('00cfb974', component.options)
    } else {
      api.reload('00cfb974', component.options)
    }
    module.hot.accept("./updataXls.vue?vue&type=template&id=00cfb974&scoped=true", function () {
      api.rerender('00cfb974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/updataXls.vue"
export default component.exports